import countDown from './countDown';

export default (di) => {
	di
		.setType({type: countDown, name: 'CountDown', parent: 'PageComponent'})
	;
};
